/*
 * 发布管理接口
 * */
import services from "../config/axios";
import base from "./base";
// 定义参数类型
type paramsType<T> = {
    [key: string]: T;
};

const publishManageAPI = {
    // 获取发布列表
    getPublishList<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetPublishList`, params);
    },
    // 获取发布审核列表
    getPublishListAudit<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetPublishListAudit`, params);
    },
    // 获取发布列表投票
    getPublishListVote<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetPublishListVote`, params);
    },
    // 新增发布申请
    addPublish<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/AddPublish`, params);
    },
    // 删除发布申请
    delPublish<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/DelPublish`, params);
    },
    // 更新发布申请
    updatePublish<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/UpdatePublish`, params);
    },
    // 管理员更新发布申请
    updateAdminPublish<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/UpdateAdminPublish`, params);
    },
    // 更新发布申请
    getPublishOne<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetPublishOne`, params);
    },
    // 获取发布审批记录
    getPublishOneAudit<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetPublishOneAudit`, params);
    },
    // 提交发布
    submitPublish<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/SubmitPublish`, params);
    },
    //退休申请
    submitPublishRetire<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/SubmitPublishRetire`, params);
    },
    //添加使用人申请
    submitPublishAddMan<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/SubmitPublishAddMan`, params);
    },
    //停用申请
    submitPublishStop<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/SubmitPublishStop`, params);
    },
    //使用申请
    submitPublishStart<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/SubmitPublishStart`, params);
    },
    // 获取流程清单
    getProcessList<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetProcessList`, params);
    },
    // 查询添加流程使用人申请历史
    getProcessAddManList<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetProcessAddManList`, params);
    },
    // 获取流程清单
    getProcessListToAsset<T>(params: FormData) {
        return services.post(
            `${base.lk}/Publish/GetProcessListToAsset`,
            params
        );
    },
    // 审批发布申请
    auditPublish<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/AuditPublish`, params);
    },
    // 审批发布申请
    auditPublishPython<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/AuditPublishPython`, params);
    },
    // 获取流程单个
    getProcessOne<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetProcessOne`, params);
    },
    // 获取发布审批清单
    getPublishAudit<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetPublishAudit`, params);
    },
    // 新增流程
    addProcess<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/AddProcess`, params);
    },
    // 修改流程
    updateProcess<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/UpdateProcess`, params);
    },
    //删除流程
    delProcess<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/DelProcess`, params);
    },
    //查询更新包列表
    getPackageList<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetPackageList`, params);
    },
    //查询更新包数量
    getPackageUpdateCount<T>(params: FormData) {
        return services.post(
            `${base.lk}/Publish/GetPackageUpdateCount`,
            params
        );
    },
    //获取流程测试发布时的加密方式
    getPublishEncrptType<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetPublishEncrptType`, params);
    },
    //获取流程测试发布时的加密方式python
    getPublishEncrptTypePython<T>(params: FormData) {
        return services.post(
            `${base.lk}/Publish/GetPublishEncrptTypePython`,
            params
        );
    },
    //更新发布包
    updatePublishPackage<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/UpdatePublishPackage`, params);
    },
    //使用某版本
    updatePackageVersion<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/UpdatePackageVersion`, params);
    },
    //获取发布流程信息
    getProcessPublish<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetProcessPublish`, params);
    },
    //获取发布项目信息
    getProjectPublish<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetProjectPublish`, params);
    },
    // 获取python项目清单
    getProjectList<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetProjectList`, params);
    },
    // 获取python项目单个
    getProjectOne<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetProjectOne`, params);
    },
    // 获取发布列表python
    getPublishListPython<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetPublishListPython`, params);
    },
    // 新增项目
    addProject<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/AddProject`, params);
    },
    // 修改项目
    updateProject<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/UpdateProject`, params);
    },
    // 修改项目参数
    updateProjectParam<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/UpdateProjectParam`, params);
    },
    //删除项目
    delProject<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/DelProject`, params);
    },
    // 新增发布申请python项目
    addPublishPython<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/AddPublishPython`, params);
    },
    // 更新发布申请python
    updatePublishPython<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/UpdatePublishPython`, params);
    },
    // 管理员更新发布申请python
    updateAdminPublishPython<T>(params: FormData) {
        return services.post(
            `${base.lk}/Publish/UpdateAdminPublishPython`,
            params
        );
    },
    // 提交发布python
    submitPublishPython<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/SubmitPublishPython`, params);
    },
    // 删除发布申请python
    delPublishPython<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/DelPublishPython`, params);
    },
    // 获取一个Python项目
    getPublishOnePython<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetPublishOnePython`, params);
    },
    //查询更新包列表
    getPackageListPython<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/GetPackageListPython`, params);
    },
    createEnv<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/CreateEnv`, params);
    },
    //更新发布包Python
    updatePublishPackagePython<T>(params: FormData) {
        return services.post(
            `${base.lk}/Publish/UpdatePublishPackagePython`,
            params
        );
    },
    //使用某版本python
    updatePackageVersionPython<T>(params: FormData) {
        return services.post(
            `${base.lk}/Publish/UpdatePackageVersionPython`,
            params
        );
    },
    // 新增包更新队列
    addPackageQueue<T>(params: FormData) {
        return services.post(`${base.lk}/Publish/AddPackageQueue`, params);
    },
};

export default publishManageAPI;
